// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Bespoke/index.css
// module id = 2066
// module chunks = 0